import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

import { AuthenticationService } from '../../services/core/authentication.service';
import { AppService } from '../../services/app.service';
import { ApiConnectionService } from '../../services/core/api-connection.service';
import { CollectionManagerService } from '../../services/core/collection-manager.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfigService } from '../../services/core/config.service';

import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-elective',
	templateUrl: './elective.component.html',
	styleUrls: ['./elective.component.scss']
})
export class ElectiveComponent implements OnInit {
	sections: any = [];
	currentUser;
	topSections: any = [];
	bottomSections: any = [];
	highlight: any = '';
	introText: any = '';
	introImage: string = '';
	cdnUrl = ''
	systemTitle = ''
	systemSlogan = ''
	systemKey = ''
	salesWebsite = ''
	sectionIntro = ''
	topSectionsIsLoaded = false;
	frontType = 'DEfAULT';
	frontTypeChapter;

	dataFetched = false;
	electiveData: any = { image: "", name: "" };
	chapters: any = [];
	choiceAssignments = [];

	existingElectives = [];

	checkLicense = false;
	banner;

	youtubeEmbedSafeURL = null;

	constructor(
		public appService: AppService,
		public apiConnectionService: ApiConnectionService,
		public authenticationService: AuthenticationService,
		public collectionManager: CollectionManagerService,
		private ngxLoader: NgxUiLoaderService,
		private dom: DomSanitizer,
		private configService: ConfigService,
		private route: ActivatedRoute,
		private changeDetection: ChangeDetectorRef
	) {
		let self = this;

		this.cdnUrl = configService.get('cdn_url');
		this.sectionIntro = configService.get('intro_text');
		this.systemTitle = configService.get('title');
		this.systemSlogan = configService.get('slogan');
		this.systemKey = configService.get('system_key');
		this.salesWebsite = configService.get('sales_website');

		self.authenticationService.data.subscribe(data => {
			if (Object.keys(data).length) {
				self.currentUser = data;
				self.frontType = this.currentUser['organisationFrontType'];

				self.getElectiveData();
				self.setSections();
			} else {
				self.currentUser = false;
				self.setSections();
				self.getElectiveData();
			}

			if (self.currentUser.role === 'ADMIN' || self.currentUser.role === 'TEACHER') {
				self.banner = configService.get('banner_teacher');
			} else {
				self.banner = configService.get('banner_student');
			}
		});
	}

	removeFirstThreeChars(str) {
		return str.slice(3);
	}

	showLogin() {
		this.appService.showLoginModal();
	}

	ngOnInit(): void {
		this.appService.navActive();
		this.appService.setPageTitle('');
		this.appService.setPageDescription('');

		let self = this;

		self.authenticationService.getCurrentUser();
		self.appService.setDefaultAuthor();
		self.appService.setDefaultMeta();
		this.introImage = this.configService.get('intro_image_url');
	}

	getElectiveData() {
		let self = this;
		if (this.dataFetched == false) {
			this.dataFetched = true;
			let id = this.route.snapshot.paramMap.get('id');
			self.ngxLoader.start();
			self.apiConnectionService.read('sections/details/' + id).then((response) => {
				self.electiveData = response;
				
				const chapters = this.configService.get('top_sections');
				for(let i = 0; i < chapters.length; i++) {
					const sel = chapters[i];
					if(sel.id == id) {
						for (let i2 = 0; i2 < sel.chapters.length; i2++) {
							self.chapters[self.chapters.length] = sel.chapters[i2];
						}
					}
				}

				if (self.currentUser != false && self.currentUser['role'] === 'TEACHER' || self.currentUser['role'] === 'ADMIN') {
					for (let i = 0; i < self.electiveData['chapters'].length; i++) {
						self.existingElectives.push(self.electiveData['chapters'][i].id);
					}
	
					self.checkLicense = true;
				}

				self.apiConnectionService.read('sections/choiceAssignments/' + id).then((data: any) => {
					for (let i = 0; i < data.length; i = i + 4) {
						const items = data.slice(i, i + 4);
						this.choiceAssignments.push(items);
					}
				});


				self.ngxLoader.stop();
			});
		}
	}

	oldHoverColor = "";

	makeColorVibrant(rgbString) {
		// Extract RGB components
		const regex = /(\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})/;
		const matches = rgbString.match(regex);
	
		if (matches) {
			// Extract RGB values
			let red = parseInt(matches[1]);
			let green = parseInt(matches[2]);
			let blue = parseInt(matches[3]);
	
			// Increase the intensity of each color component
			red = Math.min(red * 1.1, 255);
			green = Math.min(green * 1.1, 255);
			blue = Math.min(blue * 1.1, 255);
	
			// Return the modified RGB string
			return `rgb(${red}, ${green}, ${blue})`;
		} else {
			// If the RGB string is invalid, return as is
			return rgbString;
		}
	}

	hoverButton(e, state) {
		if(state) {
			this.oldHoverColor = e.target.style.backgroundColor;
			e.target.style.backgroundColor = this.makeColorVibrant(e.target.style.backgroundColor);
		} else {
			e.target.style.backgroundColor = this.oldHoverColor;
		}
	}

	setSections() {
		let self = this;

		if (self.currentUser === false) {
			this.topSections = this.configService.get('top_sections');
			this.bottomSections = this.configService.get('bottom_sections');
			return;
		}

		self.ngxLoader.start();
		self.apiConnectionService.read('sections').then((response) => {
			self.topSections = [];
			self.bottomSections = [];

			let collection: any = response;

			for (let key in collection) {
				if (collection[key]['homeTop'] == 1) {
					self.topSections.push(collection[key]);
				}
				if (collection[key]['homeBottom'] == 1) {
					self.bottomSections.push(collection[key]);
				}
			}

			self.topSectionsIsLoaded = true;
			self.ngxLoader.stop();
		});
	}

	text(lesson) {
		return this.dom.bypassSecurityTrustHtml(lesson);
	}

	numberToLetter(input) {
		const letter = ['A', 'B', 'C', 'D', 'E'];
		const selLetter = letter[input - 1];

		if(selLetter == undefined) {
			return "A";
		} else {
			return selLetter;
		}
	}

	embed(url) {
		if (this.youtubeEmbedSafeURL == null) {
			this.youtubeEmbedSafeURL = this.dom.bypassSecurityTrustResourceUrl(url);
		}
		return this.youtubeEmbedSafeURL;
	}
}
